import { Alert } from "react-bootstrap";
import TableContainer from "../genericTable/TableContainer";
import { useMemo } from "react";
import { CIRCOLANTE_COLUMNS } from "./externalDataTableColumns";

export function AccountCircolante({ accountId, circolante, loadingState, onSelectItem }) {
  const columns = useMemo(() => CIRCOLANTE_COLUMNS({ onSelectItem }), [onSelectItem])

  return (
    <div>
      {
        circolante.error ?
          (
            <Alert variant="danger">
              {circolante.error?.message}
            </Alert>
          ) :
          <TableContainer
            dblClickCallback={onSelectItem}
            columns={columns}
            data={circolante.data}
            loading={loadingState.isLoadingCircolante}
            error={circolante.error}
          ></TableContainer>
      }
    </div>
  )
}
